import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { COMPANY_STATUS, COMPANY_STATUS_LABEL } from 'constants/company';
import { SelectAdvancedFilterOptionType } from 'types/common';

import { useCommunitiesContext } from './CommunitiesContext';

const CommunitiesControlsFiltersCompanyStatus = () => {
  const { filters, setFilters } = useCommunitiesContext();

  const handleSelectCompanyStatus = (values: SelectAdvancedFilterOptionType[]) => {
    const selection = (values ?? []).map((item: SelectAdvancedFilterOptionType) => item.value);
    setFilters({ ...filters, companyStatus: selection });
  };

  const companyStatusOptions = Object.values(COMPANY_STATUS).map((companyStatusId) => ({
    label: COMPANY_STATUS_LABEL[companyStatusId],
    value: companyStatusId,
  }));

  return (
    <SelectAdvancedFilter
      className={classNames({ active: filters?.companyStatus && filters.companyStatus.length > 0 })}
      placeholder={'Company Status'}
      options={companyStatusOptions}
      defaultValue={filters?.companyStatus ?? []}
      onSelect={handleSelectCompanyStatus}
    />
  );
};

export default CommunitiesControlsFiltersCompanyStatus;
